module.exports = __webpack_public_path__ + "media/images/loginicon-ff56f75c8594602b54b44aa91e025532.jpg";